import {roLogger} from '@app/helpers/roLogger';


export class NgRoDebugger {
  protected logger;
  constructor(loggerContext: string) {
    this.logger = roLogger({ context: loggerContext });
  }
}
